<template>
	<div>
		<div class="tw-text-3xl tw-font-bold" v-if="!isDone">
			{{ $t('integrations.import-products-title', { marketplace: marketplaceName }) }}
		</div>
		<div class="tw-flex tw-items-center tw-gap-2" v-else>
			<div class="tw-text-3xl tw-font-bold">{{ $t('integrations.products-imported') }}</div>
			<div
				class="'tw-border-secondary-500 tw-z-10 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-bg-secondary-500 tw-text-white"
				style="width: 32px; height: 32px"
			>
				<AppIcon name="check" />
			</div>
		</div>
		<div class="tw-font-medium tw-text-gray-500">
			{{ $t('integrations.import-products-description', { marketplace: marketplaceName }) }}
		</div>
		<div class="tw-mt-5" v-if="!isDone">
			<AppButton
				:label="loading ? $t('integrations.importing') : $t('integrations.import-products')"
				size="xl"
				endIcon="assets/v2/image/icons/upload.svg"
				class="tw-rounded-full"
				:disabled="loading"
				@click="reImport"
			/>
		</div>
		<div class="tw-mt-5 tw-flex tw-items-center tw-gap-3" v-else>
			<AppButton
				:label="$t('integrations.re-import-products')"
				size="xl"
				class="tw-rounded-full"
				type="button"
				secondary
				variant="gray"
				endIcon="assets/v2/image/icons/upload.svg"
				:disabled="loading"
				@click="reImport"
			/>
			<AppButton
				:label="$t('integrations.next-step')"
				size="xl"
				class="tw-rounded-full"
				type="button"
				endIcon="assets/v2/image/icons/arrow-narrow-right.svg"
				@click="nextStep"
				:disabled="nextStepLoading"
			/>
		</div>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { marketplaceStepStatusEnum } from '../../helper';
import { Marketplace } from '../../../../entities/marketplace';
import { Alert } from '@/v2/plugins/alert';

const linkMarketplaceStore = useLinkMarketplaceStore();

const loading = ref(false);
const isDone = ref(
	linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.Complete,
);

const marketplaceName = computed(() => {
	return linkMarketplaceStore.marketplace.name || '';
});

const reImport = async () => {
    loading.value = true;
    isDone.value = false;
    try {
        const { data } = await Marketplace.importProducts(linkMarketplaceStore.linkedMarketplaceId);
        if (data?.success) {
            // advance on success
            await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
            await linkMarketplaceStore.refetchSteps();
            isDone.value = true;
        } else {
            Alert.error(data?.message);
        }
    } finally {
        loading.value = false;
    }
};

const nextStepLoading = ref(false);
const nextStep = async () => {
	nextStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
	} finally {
		nextStepLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
